import { render, staticRenderFns } from "./CandidateValidator.vue?vue&type=template&id=58b32531&"
import script from "./CandidateValidator.vue?vue&type=script&lang=js&"
export * from "./CandidateValidator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports